import { axios } from '@complispace/cs-design-system';

const baseURL = process.env.CONTENT_ENGINE_URL;

const auditLogs = {
  // GET /app/audits
  async getAuditLogs({ startDate, endDate, keywords }) {
    const auditSearchUrl = `${baseURL}/app/audits`;

    return axios.get(auditSearchUrl, {
      params: {
        start_date: startDate,
        end_date: endDate,
        keywords
      }
    });
  }
};

export default auditLogs;
